// import React from "react";
// import {
//   Box,
//   Flex,
//   Text,
//   Button,
//   SimpleGrid,
//   Center,
// } from "@chakra-ui/react";
// import { Link } from "react-router-dom";

// // ----------- Custom Chakra-Compatible Icons -----------

// const ArrowRightIcon = () => (
//   <svg
//     width="20"
//     height="20"
//     viewBox="0 0 24 24"
//     stroke="#FFFFFF"
//     strokeWidth="2"
//     fill="none"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <line x1="5" y1="12" x2="19" y2="12" />
//     <polyline points="12 5 19 12 12 19" />
//   </svg>
// );

// const MailIcon = () => (
//   <svg
//     width="22"
//     height="22"
//     viewBox="0 0 24 24"
//     stroke="#2AA198"
//     strokeWidth="2"
//     fill="none"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <rect x="3" y="4" width="18" height="16" rx="2" />
//     <polyline points="3 6 12 13 21 6" />
//   </svg>
// );

// // ------------------------------------------------------

// const MarketSection = () => {
//   return (
//     <Box w="full" py="32" bg="#F7FAFC">
//       <Box maxW="4xl" mx="auto" px="6" textAlign="center">

//         {/* Top Icon */}
//         <Flex justify="center" mb="10">
//           <Center bg="#E3EAF3" p="6" rounded="2xl">
//             <Box w="3" h="3" bg="#2AA198" rounded="full" />
//           </Center>
//         </Flex>

//         {/* Main Heading */}
//         <Text
//           fontSize="5xl"
//           fontFamily="serif"
//           fontWeight="bold"
//           color="#1A2C4E"
//           lineHeight="1.2"
//         >
//           Ready to see <Text as="span" color="#2AA198">your</Text> <br /> market more clearly?
//         </Text>

//         {/* Subtitle */}
//         <Text
//           mt="6"
//           fontSize="xl"
//           color="gray.600"
//           lineHeight="tall"
//         >
//           Start exploring insights tailored to your industry <br />—no commitment, no complex setup.
//         </Text>

//         {/* Buttons */}
//         <Flex
//           mt="12"
//           direction={{ base: "column", sm: "row" }}
//           justify="center"
//           gap="6"
//         >
//           {/* Explore Insights */}
//           <Button
//             bg="#2AA198"
//             color="white"
//             fontSize="lg"
//             px="10"
//             py="4"
//             rounded="xl"
//             shadow="sm"
//             _hover={{ bg: "#1F7A73" }}
//             display="flex"
//             alignItems="center"
//             gap="2"
//           >
//             Explore Insights
//             <ArrowRightIcon />
//           </Button>

//           {/* Request Early Access */}
//           <Button
//             bg="white"
//             border="1px solid"
//             borderColor="gray.300"
//             fontSize="lg"
//             px="10"
//             py="4"
//             rounded="xl"
//             fontWeight="medium"
//             color="#2AA198"
//             shadow="sm"
//             _hover={{ bg: "gray.100" }}
//             display="flex"
//             alignItems="center"
//             gap="3"
//           >
//             <MailIcon />
//             Request Early Access
//           </Button>
//         </Flex>

//       </Box>
//     </Box>
//   );
// };

// export default MarketSection;

import React, { useEffect } from "react";
import {
  Box,
  Flex,
  Text,
  Button,
  Center,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  getSectorCategories,
  getAllSectors,
} from "../actions/sector/sectorActions";

// ----------- Custom Chakra-Compatible Icons -----------

const ArrowRightIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    stroke="#FFFFFF"
    strokeWidth="2"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

const MailIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    stroke="#2AA198"
    strokeWidth="2"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <polyline points="3 6 12 13 21 6" />
  </svg>
);

// ------------------------------------------------------

const MarketSection = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    categories = [],
    data: products = [],
  } = useSelector((state) => state.sectorSmmReducer || {});

  // Load categories
  useEffect(() => {
    if (!categories.length) {
      dispatch(getSectorCategories());
    }
  }, [dispatch]);

  // Load sectors
  useEffect(() => {
    if (categories.length > 0 && products.length === 0) {
      dispatch(getAllSectors(categories[0]));
    }
  }, [categories, dispatch]);

  // Extract sector id
  const sectorId = products?.[0]?.id;

  const handleExplore = () => {
    if (sectorId) {
      navigate(`/sector/${sectorId}/details`);
    }
  };

  return (
    <Box w="full" py="32" bg="#F7FAFC">
      <Box maxW="4xl" mx="auto" px="6" textAlign="center">

        {/* Top Icon */}
        <Flex justify="center" mb="10">
          <Center bg="#E3EAF3" p="6" rounded="2xl">
            <Box w="3" h="3" bg="#2AA198" rounded="full" />
          </Center>
        </Flex>

        {/* Main Heading */}
        <Text
          fontSize="5xl"
          fontFamily="serif"
          fontWeight="bold"
          color="#1A2C4E"
          lineHeight="1.2"
        >
          Ready to see <Text as="span" color="#2AA198">your</Text> <br /> market more clearly?
        </Text>

        {/* Subtitle */}
        <Text
          mt="6"
          fontSize="xl"
          color="gray.600"
          lineHeight="tall"
        >
          Start exploring insights tailored to your industry <br />—no commitment, no complex setup.
        </Text>

        {/* Buttons */}
        <Flex
          mt="12"
          direction={{ base: "column", sm: "row" }}
          justify="center"
          gap="6"
        >
          {/* Explore Insights */}
          <Button
            onClick={handleExplore}
            bg="#2AA198"
            color="white"
            fontSize="lg"
            px="10"
            py="4"
            rounded="xl"
            shadow="sm"
            _hover={{ bg: "#1F7A73" }}
            display="flex"
            alignItems="center"
            gap="2"
          >
            Explore Insights
            <ArrowRightIcon />
          </Button>

          {/* Request Early Access */}
          <Button
            bg="white"
            border="1px solid"
            borderColor="gray.300"
            fontSize="lg"
            px="10"
            py="4"
            rounded="xl"
            fontWeight="medium"
            color="#2AA198"
            shadow="sm"
            _hover={{ bg: "gray.100" }}
            display="flex"
            alignItems="center"
            gap="3"
          >
            <MailIcon />
            Request Early Access
          </Button>
        </Flex>

      </Box>
    </Box>
  );
};

export default MarketSection;